import { ComponentType, ComponentInstance } from "./component";

class ResponsiveTable extends ComponentInstance {
  #headers = [];

  wrapCellContent(cell) {
    if (cell.querySelector(".td-content")) return;

    const wrapper = document.createElement("div");
    wrapper.className = "td-content";

    while (cell.firstChild) {
      wrapper.appendChild(cell.firstChild);
    }

    cell.appendChild(wrapper);
  }

  normalizeText(text) {
    return text.replace(/&nbsp;|\u00A0/g, " ").trim();
  }

  getHeaderLabel(th) {
    const paragraphs = th.querySelectorAll("p");

    const text = paragraphs.length
      ? Array.from(paragraphs)
          .map((p) => p.textContent)
          .join("\n")
      : th.textContent;

    return this.normalizeText(text);
  }

  processTable() {
    this.el.querySelectorAll("tbody tr").forEach((row) => {
      Array.from(row.children).forEach((cell, index) => {
        const tagName = cell.tagName;
        if (
          (tagName === "TD" || tagName === "TH") &&
          !cell.hasAttribute("data-label") &&
          this.#headers[index]
        ) {
          cell.setAttribute("data-label", this.#headers[index]);
        }

        this.wrapCellContent(cell);
      });
    });
  }

  bindHandlers() {
    this.getHeaderLabel = this.getHeaderLabel.bind(this);
    this.normalizeText = this.normalizeText.bind(this);
    this.processTable = this.processTable.bind(this);
    this.wrapCellContent = this.wrapCellContent.bind(this);
  }

  init() {
    if (window.innerWidth > 767) {
      return;
    }

    const thead = this.el.querySelector("thead");
    this.bindHandlers();

    if (thead) {

      this.#headers = Array.from(thead.querySelectorAll("th")).map(
        this.getHeaderLabel,
      );

      if (!this.#headers.length) {
        return;
      }

      this.processTable();
    } else {
      Array.from(this.el.querySelectorAll('tbody td')).forEach(td => {
        td.innerHTML = this.normalizeText(td.innerHTML)
      })
    }
  }
}

new ComponentType(ResponsiveTable, "table", ".table");
